var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.items || !_vm.items.length)?_c('div',[_vm._v("No data found")]):_vm._e(),_vm._l((_vm.items),function(item,index){return _c('a',{key:'reminder' + index,class:_vm.$style.item,on:{"click":function($event){return _vm.click(item, _vm.items)}}},[_c('span',[_vm._v(_vm._s(item.Description))]),_c('b',[_vm._v(_vm._s(item.DueDate))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }